
import { useEffect } from 'react';

interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function BookingModal({ isOpen, onClose }: BookingModalProps) {
  useEffect(() => {
    if (isOpen) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-[#042A60]/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      
      <div className="relative bg-white w-full max-w-2xl max-h-[90vh] overflow-hidden">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl text-[#042A60] font-light">
              Klarheitsgespräch buchen
            </h2>
            <button 
              onClick={onClose}
              className="w-10 h-10 flex items-center justify-center text-[#042A60] hover:text-[#0A6AF0] transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>

          <p className="text-sm text-[#042A60]/70 mb-4">
            In 30 Minuten Klarheit: Wo stehst du? Welche 1–2 KI-Assistent:innen bringen den größten Hebel?
          </p>

          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/eva-klar-ki-jdis/30min?hide_gdpr_banner=1&background_color=ffffff&text_color=042a60&primary_color=0a6af0"
            style={{ minWidth: '320px', height: '630px' }}
          ></div>
        </div>
      </div>
    </div>
  );
}
